import React, { memo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button, Icon, Stack, useMediaQuery } from 'investira.react.components';
import { PortfolioTemplate } from '../../components/templates';
import withPortfolios from '../../hoc/withPortfolios';
import { usePortfoliosContext } from '../../contexts/PortfolioContext';
import { acPortfoliosSelected } from '../../store/actions';
import usePerfil from '../../hooks/usePerfil';

const Portfolios = memo(props => {
  const navigate = useNavigate();

  const { actions } = usePortfoliosContext();
  const isUpSm = useMediaQuery(theme => theme.breakpoints.up('sm'));
  const storeDispatch = useDispatch();

  const { usuarioPrioridade } = usePerfil();

  useEffect(() => {
    storeDispatch(acPortfoliosSelected({}));
  }, []);

  return (
    <PortfolioTemplate
      title="Portfolios"
      headerRenderActions={
        usuarioPrioridade <= 6 && (
          <Stack direction="row" spacing={2}>
            <Button
              disabled={props.disabledButtons}
              variant="contained"
              color="primary"
              startIcon={<Icon iconName="insert" size={16} />}
              size="small"
              sx={{ px: 2 }}
              onClick={() => navigate('/portfolios/add')}>
              {isUpSm ? 'Novo Portfolio' : 'Novo'}
            </Button>
          </Stack>
        )
      }
      dataGridProps={{
        data: props.portfolios,
        readData: props.readPortfolios,
        isLoading: props.isLoading,
        initialState: { pagination: props.pagination },
        manualPagination: true,

        getRowId: row => {
          return row.carteira_id;
        },
        state: {
          isLoading: props.isLoading,
          pagination: props.pagination,
          showProgressBars: props.isRefetching,
          rowSelection: props.rowSelection
        },
        rowCount: props.rowCount,
        onPaginationChange: props.setPagination,
        onRowSelectionChange: props.setRowSelection,
        onEditClick: actions.handleEditPortfolio,
        onDeleteClick: props.deletePortfolio,
        onBulkDeleteClick: props.bulkDeletePortfolios
      }}
    />
  );
});

Portfolios.displayName = 'Portfolios';

export default withPortfolios(Portfolios);
